import { ViewModel, View, ObservableArray } from "binder"
import { MeasuredParameterGroupView } from "./measuredParameterGroup-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { FileChooser, stringIsNullOrEmpty } from "src/common/utilities";
import { downloadFile } from "src/uicomponents/components/utilities";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class MeasuredParameterGroupViewModel extends WindowViewModel {
    public getTitle(): string {
        return "تعریف مشخصات اندازه گیری";
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.groups = ObservableArray.create<MeasuredParameterGroup>();
        this.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new MeasuredParameterGroupView();
    }
    public getTypeId(): string {
        return "VM-26C0A696-B822-4B2C-99C5-EF767965D306"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set groups(v: ObservableArray<MeasuredParameterGroup>) { this._groups = v; } public get groups(): ObservableArray<MeasuredParameterGroup> { return this._groups; } private _groups: ObservableArray<MeasuredParameterGroup>;

    async refresh(): Promise<void> {
        await this.loadGroups();
    }

    async loadGroups(): Promise<void> {
        try {
            this.isLoading = true;
            let serverResult = await ServerConnection.callServer('/Complex/ControlPlanService/GetAllMeasureParameterGroups', {});

            this.groups.update(...serverResult.Groups.map(item => {
                let group: MeasuredParameterGroup = new MeasuredParameterGroup(this);
                group.id = item.Id;
                group.name = item.Name;
                group.tag = item.Tag;
                group.children.update(...item.Children.filter(q => q.Enable == true).map(child => this.convertToChild(child, group)));
                group.removeChildren.update(...item.Children.filter(q => q.Enable == false).map(child => this.convertToChild(child, group)));
                group.hasRemovedChild = group.removeChildren.length != 0;
                return group;
            }))
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    convertToChild(dto: any, parent): MeasuredParameter {
        let measuredParameter: MeasuredParameter = new MeasuredParameter(parent);
        measuredParameter.id = dto.Id;
        measuredParameter.name = dto.Name;
        measuredParameter.measurementMethod = dto.MeasurementMethod;
        measuredParameter.unitName = dto.Unit;
        measuredParameter.enable = dto.Enable;
        measuredParameter.canRemove = measuredParameter.enable;
        return measuredParameter;
    }

    async save(): Promise<void> {
        let validationResult = this.validation();
        if (validationResult.length > 0) {
            await this.messageBoxConfirmWarning(validationResult.join("\n"), "ثبت گروه مشخصات");
            return;
        }
        try {
            this.isLoading = true;
            let serverResult = await ServerConnection.callServer('/Complex/ControlPlanService/SynchroniseMeasureParameterGroups', {
                Groups: this.groups.map(item => {
                    return {
                        Id: item.id,
                        Name: item.name,
                        Tag: item.tag,
                        Children: item.children.merge(item.removeChildren).map(child => {
                            return {
                                Id: child.id,
                                Name: child.name,
                                MeasurementMethod: child.measurementMethod,
                                Enable: child.enable,
                                UnitName: child.unitName
                            }
                        })
                    }
                })
            });

            if (serverResult.IsSuccessful) {
                await this.messageBoxConfirmSuccess("اطلاعات با موفقیت ذخیره سازی شد.", "ثبت گروه مشخصات")
                this.refresh();
            } else {
                if (serverResult.Faults[0].Parameters.FaultId == '096473E7-67AE-4206-9B61-79B70943684A') {
                    await this.messageBoxConfirmWarning("سطور تکراری است.", "خطا در عملیات");
                }
            }
        } catch (ex) {
            await this.messageBoxConfirmWarning("خطا در عملیات", "خطا در عملیات");
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    validation(): string[] {
        let validation = [];
        this.groups.forEach(group => {
            group.children.forEach((child, index) => {
                if (stringIsNullOrEmpty(child.name)) {
                    validation.push(`برای گروه ${group.name} در سطر ${index} نام مشخصه وارد نشده است.`)
                }
                if (stringIsNullOrEmpty(child.measurementMethod)) {
                    validation.push(`برای گروه ${group.name} در سطر ${index} روش اندازه گیری مشخصه وارد نشده است.`)
                }
                if (stringIsNullOrEmpty(child.unitName)) {
                    validation.push(`برای گروه ${group.name} در سطر ${index} واحد اندازه گیری مشخصه وارد نشده است.`)
                }
            })
        });

        return validation;
    }

    async downloadExcelTemplate(): Promise<void> {
        try {
            this.isLoading = true;
            let serverResult = await ServerConnection.callServer('/Complex/ControlPlanService/DownloadExcelTemplateForImportMeasureParameter', {});

            if (serverResult.IsSuccessful) {
                downloadFile(serverResult.ExcelFile, "MeasureParameterTemplete.xlsx");
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async importMeasureParamtersFromExcelFile(groupId: string): Promise<void> {
        try {
            let fileChooser = new FileChooser();
            let file = await fileChooser.chooseFile()
            if (file.isChoosed == true) {
                this.isLoading = true;
                let serverResult = await ServerConnection.callServer('/Complex/ControlPlanService/ImportMeasureParameterFromExcelFile', {
                    MeasureParameterGroupId: groupId,
                    ExcelFile: file.fileContent
                });

                if (serverResult.IsSuccessful) {
                    await this.messageBoxConfirmSuccess("اطلاعات با موفقیت ذخیره سازی شد.", "ثبت گروه مشخصات")
                    this.refresh();
                } else {
                    if (serverResult.Faults[0].Parameters.FaultId == '096473E7-67AE-4206-9B61-79B70943684A') {
                        await this.messageBoxConfirmWarning("سطور تکراری است.", "خطا در عملیات");
                    }
                }
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async showMeasureParameterGroupSpecification(measuredParameterGroup: MeasuredParameterGroup) {
        measuredParameterGroup.loadSpecifications();
        let result = await this.showPopup(measuredParameterGroup);
        if (result) {
            this.refresh();
        }
    }
}

export class MeasuredParameterGroup extends ViewModel implements IPopup {
    public getTypeId(): string { return 'measuredParameterGroup'; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: MeasuredParameterGroupViewModel) {
        super(parent);
        this._parent = parent;
        this.children = ObservableArray.create<MeasuredParameter>();
        this.removeChildren = ObservableArray.create<MeasuredParameter>();
        this.specifications = ObservableArray.create<MeasureParameterGroupSpecification>();
    }

    closePopup(result: boolean = false) {
        return result;
    }

    private _parent: MeasuredParameterGroupViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set tag(v: string) { this._tag = v; } public get tag(): string { return this._tag; } private _tag: string;
    public set children(v: ObservableArray<MeasuredParameter>) { this._children = v; } public get children(): ObservableArray<MeasuredParameter> { return this._children; } private _children: ObservableArray<MeasuredParameter>;
    public set removeChildren(v: ObservableArray<MeasuredParameter>) { this._removeChildren = v; } public get removeChildren(): ObservableArray<MeasuredParameter> { return this._removeChildren; } private _removeChildren: ObservableArray<MeasuredParameter>;
    public set specifications(v: ObservableArray<MeasureParameterGroupSpecification>) { this._specifications = v; } public get specifications(): ObservableArray<MeasureParameterGroupSpecification> { return this._specifications; } private _specifications: ObservableArray<MeasureParameterGroupSpecification>;
    public set showChildren(v: boolean) { this._showChildren = v; } public get showChildren(): boolean { return this._showChildren; } private _showChildren: boolean;
    public set hasRemovedChild(v: boolean) { this._hasRemovedChild = v; } public get hasRemovedChild(): boolean { return this._hasRemovedChild; } private _hasRemovedChild: boolean;
    public set specificationTitle(v: string) { this._specificationTitle = v; } public get specificationTitle(): string { return this._specificationTitle; } private _specificationTitle: string;

    addChild(): void {
        let child: MeasuredParameter = new MeasuredParameter(this);
        child.canRemove = true;
        child.enable = true;
        this.showChildren = true;
        this.children.push(child);
    }

    removeChild(child: MeasuredParameter): void {
        child.enable = false;
        child.canRemove = false;
        this.children.remove(child);
        if (child.id != null) {
            this.removeChildren.push(child);
            this.hasRemovedChild = true;
        }
    }

    restoreChild(child: MeasuredParameter): void {
        child.enable = true;
        child.canRemove = true;
        this.removeChildren.remove(child);
        this.children.push(child);
        this.hasRemovedChild = this.removeChildren.length != 0;
    }

    toggleDetail() {
        this.showChildren = !this.showChildren;
    }

    importFromExcelFile(): void {
        this._parent.importMeasureParamtersFromExcelFile(this.id);
    }

    async addSpecification(): Promise<void> {
        let specification: MeasureParameterGroupSpecification = new MeasureParameterGroupSpecification(this);
        specification.title = this.specificationTitle;
        specification.showValues = true;
        specification.canRemove = true;
        this.specifications.push(specification);
        this.specificationTitle = null;
    }

    async showSpecification(): Promise<void> {
        await this._parent.showMeasureParameterGroupSpecification(this);
    }

    async loadSpecifications(): Promise<void> {
        try {
            this.isLoading = true;
            let serverResult = await ServerConnection.callServer('/Complex/ControlPlanService/LoadAllMeasureParameterGroupSpecification', { GroupId: this.id });
            this.specifications.update(...serverResult.Specifications.map(item => this.convertToSpecification(item)));
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    convertToSpecification(dto: any) {
        let specification = new MeasureParameterGroupSpecification(this);
        specification.id = dto.Id;
        specification.title = dto.Title;
        specification.canRemove = false;
        specification.values.update(...dto.Values.map(item => {
            let value = new MeasureParameterGroupSpecificationValue(specification);
            value.id = item.Id;
            value.value = item.Value;
            value.canRemove = false;
            return value;
        }));
        return specification;
    }

    async synchroniseSpecifications() {
        try {
            this.isLoading = true;
            let serverResult = await ServerConnection.callServer('/Complex/ControlPlanService/SynchroniseMeasureParameterGroupSpecifications', {
                GroupId: this.id,
                Specifications: this.specifications.map(specification => {
                    return {
                        Id: specification.id,
                        Title: specification.title,
                        Values: specification.values.map(value => {
                            return {
                                Id: value.id,
                                Value: value.value
                            }
                        })
                    }
                })
            });

            if (serverResult.IsSuccessful) {
                this.messageBoxConfirmSuccess("تغییرات با موفقیت ثبت و ذخیره شد.", "ویژگی های گروه");
                this.closePopup(true);
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    back() {
        this.closePopup();
    }

    removeSpecification(specification:MeasureParameterGroupSpecification){
        this.specifications.remove(specification);
    }
}

export class MeasuredParameter extends ViewModel {
    public getTypeId(): string { return 'child'; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: MeasuredParameterGroup) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent: MeasuredParameterGroup;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set measurementMethod(v: string) { this._measurementMethod = v; } public get measurementMethod(): string { return this._measurementMethod; } private _measurementMethod: string;
    public set unitName(v: string) { this._unitName = v; } public get unitName(): string { return this._unitName; } private _unitName: string;
    public set enable(v: boolean) { this._enable = v; } public get enable(): boolean { return this._enable; } private _enable: boolean;
    public set canRemove(v: boolean) { this._canRemove = v; } public get canRemove(): boolean { return this._canRemove; } private _canRemove: boolean;


    restore(): void {
        this._typedParent.restoreChild(this);
    }

    remove(): void {
        this._typedParent.removeChild(this);
    }
}

export class MeasureParameterGroupSpecification extends ViewModel {
    public getTypeId(): string { return 'measureParameterGroupSpecification'; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: MeasuredParameterGroup) {
        super(parent);
        this.values = ObservableArray.create<MeasureParameterGroupSpecificationValue>();
        this.showValues = false;
        this._typedParent = parent;
    }

    private _typedParent:MeasuredParameterGroup;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
    public set values(v: ObservableArray<MeasureParameterGroupSpecificationValue>) { this._values = v; } public get values(): ObservableArray<MeasureParameterGroupSpecificationValue> { return this._values; } private _values: ObservableArray<MeasureParameterGroupSpecificationValue>;
    public set showValues(v: boolean) { this._showValues = v; } public get showValues(): boolean { return this._showValues; } private _showValues: boolean;
    public set newValue(v: string) { this._newValue = v; } public get newValue(): string { return this._newValue; } private _newValue: string;
    public set canRemove(v: boolean) { this._canRemove = v; } public get canRemove(): boolean { return this._canRemove; } private _canRemove: boolean;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    toggleDetail() {
        this.showValues = !this.showValues;
    }

    removeValue(value: MeasureParameterGroupSpecificationValue) {
        this.values.remove(value);
    }

    addValue() {
        let newValue: MeasureParameterGroupSpecificationValue = new MeasureParameterGroupSpecificationValue(this);
        newValue.value = this.newValue;
        newValue.canRemove = true;
        this.values.push(newValue);
        this.newValue = null;
    }

    remove(){
        this._typedParent.removeSpecification(this);
    }
}

export class MeasureParameterGroupSpecificationValue extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: MeasureParameterGroupSpecification) {
        super(parent);
        this.canRemove = true;
        this._typedParent = parent;
    }

    private _typedParent: MeasureParameterGroupSpecification;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set value(v: string) { this._value = v; } public get value(): string { return this._value; } private _value: string;
    public set canRemove(v: boolean) { this._canRemove = v; } public get canRemove(): boolean { return this._canRemove; } private _canRemove: boolean;

    remove() {
        this._typedParent.removeValue(this);
    }
}
